import { create } from "zustand";

interface StoreState {
  currentTime: number;
  setCurrentTime: (currentTime: number) => void;
}

const useUserStore = create<StoreState>((set) => ({
  currentTime: 0,
  setCurrentTime: (currentTime) =>
    set((state) => ({
      ...state,
      currentTime,
    })),
}));

export default useUserStore;
